var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "-1.92 -1.92 27.84 27.84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.048
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,18.2457306 C18.873179,16.7457534 20,14.4691356 20,12 C20,7.76611275 16.7007403,4.27177627 12.4954564,4.01507576 C12.2198271,3.9982507 12.0100247,3.76116956 12.0268498,3.48554023 C12.0436749,3.2099109 12.280756,3.00010859 12.5563854,3.01693366 C17.2885352,3.30579531 21,7.23670954 21,12 C21,14.7629547 19.7449158,17.3127321 17.6577582,19 L20.5,19 C20.7761424,19 21,19.2238576 21,19.5 C21,19.7761424 20.7761424,20 20.5,20 L16.5,20 C16.2238576,20 16,19.7761424 16,19.5 L16,15.5 C16,15.2238576 16.2238576,15 16.5,15 C16.7761424,15 17,15.2238576 17,15.5 L17,18.2457306 L17,18.2457306 Z M7,5.75425899 C5.12699441,7.25408222 4,9.53070623 4,12 C4,16.2473817 7.31964678,19.7484245 11.5408239,19.987057 C11.816526,20.0026431 12.0273918,20.2387789 12.0118058,20.514481 C11.9962197,20.7901832 11.7600839,21.001049 11.4843818,20.9854629 C6.7344127,20.7169366 3,16.7784637 3,12 C3,9.23687221 4.25526581,6.68710337 6.34222866,5 L3.5,5 C3.22385763,5 3,4.77614237 3,4.5 C3,4.22385763 3.22385763,4 3.5,4 L7.5,4 C7.77614237,4 8,4.22385763 8,4.5 L8,8.5 C8,8.77614237 7.77614237,9 7.5,9 C7.22385763,9 7,8.77614237 7,8.5 L7,5.75425899 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendIcon);
export default __webpack_public_path__ + "static/media/resend-icon.faa1d38543e4def54deb3b86f86a32cb.svg";
export { ForwardRef as ReactComponent };